module.exports = __webpack_public_path__ + "static/section-1-animation-cae3180d084ad6f9d8aa4a905ed995d8.png";